import IntegrazioneBusiness from "../";

const routes = [
  { name: "IntegrazioneBusinessList", path: "/integrazionebusiness", component: IntegrazioneBusiness.IntegrazioneBusinessList },
  { name: "IntegrazioneBusinessView", path: "/integrazionebusiness/view/:id", component: IntegrazioneBusiness.IntegrazioneBusinessView }
];

export default routes;
